import '/components/related-producers-carousel/related-producers-carousel';
import '/components/related-producers-carousel/related-producers-carousel.scss';
